import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';

import { Col } from '@bingads-webui-react/layout';
import { LogoImage } from './logo-image';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '60px',
  },
  logo: {
    height: '20px',
    width: '100px',
  },
  logoClickable: {
    cursor: 'pointer',
  },
  logoContainer: {
    padding: `0 ${tokens.spacingHorizontalXL}`,
    height: '20px',
  },
  divider: {
    borderLeftColor: 'black',
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    height: '24px',
    width: '0px',
  },
  item: {
    marginLeft: '0px',
    marginRight: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: '#646464',
    fontSize: '17px',
    lineHeight: '19px',
    fontStyle: 'normal',
    textAlign: 'center',
    paddingLeft: tokens.spacingHorizontalXL,
    fontWeight: tokens.fontWeightMedium,
  },
});

const HeaderComponent = () => {
  const classes = useStyles();
  return (
    <header className={classes.container} role="banner">
      <Col className={classes.item}>
        <div className={classes.logoContainer}>
          <Link to="/" aria-label="Microsoft logo">
            <LogoImage
              className={classnames(classes.logo, classes.logoClickable)}
            />
          </Link>
        </div>
      </Col>
      <Col className={classes.item}>
        <div className={classes.divider} />
      </Col>
      <Col className={classes.item}>
        <span className={classes.text}>Ad library</span>
      </Col>
    </header>
  );
};

export const Header = HeaderComponent;
